export default "__VITE_ASSET__o$AbYfWn__"